<template>
  <div class="topbar" style="height: 6rem">
    <!--
        <b-dropdown size="sm" variant="link" toggle-class="topbar-item text-decoration-none" no-caret right no-flip>
            <template v-slot:button-content>
                <div class="btn btn-icon btn-clean btn-lg pulse pulse-primary">
                    <span class="svg-icon svg-icon-xl">
                        <inline-svg src="/media/svg/icons/communication/recent-notification.svg"/>
                    </span>

                    <span class="pulse-ring"></span>
                </div>
            </template>

            <b-dropdown-text tag="div" style="min-width: 338px;">
                <notification></notification>
            </b-dropdown-text>
        </b-dropdown>
        -->

    <user></user>
  </div>
</template>

<script>
import Notification from "./notification";
import User from "./user";

export default {
  name: "TopBar",
  components: {
    Notification,
    User,
  },
};
</script>
